"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SortIcon = exports.FilterIcon = exports.TableHeaderCell = exports.TableHeader = exports.TableCell = exports.TableRow = exports.TableBody = exports.Table = void 0;

var _react = _interopRequireDefault(require("react"));

var _styled = _interopRequireWildcard(require("../../styled"));

var _react2 = _interopRequireDefault(require("@mdi/react"));

var _js = require("@mdi/js");

var _IconButton = _interopRequireDefault(require("../IconButton"));

var _polished = require("polished");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

/**
 * A set of table components for building tables. The exported components are:
 *
 * The exported components are:
 *
 * - `Table` (`table`)
 * - `TableHeader` (`thead`)
 * - `TableHeaderCell` (`th`)
 * - `TableBody` (`tbody`)
 * - `TableRow` (`tr`)
 * - `TableCell` (`td`)
 *
 * See examples below on how they're meant to be composed together.
 *
 * @component
 */
var Table = _styled["default"].table(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  border-spacing: 0;\n  border-collapse: collapse;\n  box-shadow: ", ";\n  border-radius: 5px;\n  overflow: hidden;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.shadows[1];
});
/** @component */


exports.Table = Table;

var TableBody = _styled["default"].tbody(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral([""])));
/** @component */


exports.TableBody = TableBody;

var TableRow = _styled["default"].tr(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  &:last-child {\n    border-bottom-width: 0;\n  }\n"])));
/** @component */


exports.TableRow = TableRow;

var TableCell = _styled["default"].td(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  padding: 5px 10px;\n\n  &:first-child {\n    border-left-width: 0;\n  }\n  &:last-child {\n    border-right-width: 0;\n  }\n  &:nth-child(odd) {\n    background-color: ", ";\n    border-bottom: 1px solid\n      ", ";\n  }\n  &:nth-child(even) {\n    background-color: ", ";\n    border-bottom: 1px solid ", ";\n  }\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.background;
}, function (_ref3) {
  var theme = _ref3.theme;
  return (0, _polished.mix)(0.89, theme.background, theme.foreground);
}, function (_ref4) {
  var theme = _ref4.theme;
  return (0, _polished.mix)(0.89, theme.background, theme.foreground);
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.background;
});
/** @component */


exports.TableCell = TableCell;

var TableHeader = _styled["default"].thead(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  background-color: ", ";\n\n  ", " {\n    background-color: transparent;\n    border-bottom-width: 0;\n  }\n"])), function (_ref6) {
  var theme = _ref6.theme;
  return theme.foreground;
}, TableRow);
/** @component */


exports.TableHeader = TableHeader;

var TableHeaderCell = _styled["default"].th(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  padding: 5px 10px;\n  font-weight: normal;\n  color: ", ";\n  border: 1px solid\n    ", ";\n"])), function (_ref7) {
  var theme = _ref7.theme;
  return theme.background;
}, function (_ref8) {
  var theme = _ref8.theme;
  return (0, _polished.mix)(0.75, theme.foreground, theme.background);
});

exports.TableHeaderCell = TableHeaderCell;
var FilterIconElement = (0, _styled["default"])(_IconButton["default"])(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  grid-area: filter;\n  margin: 0 0.375rem 0 0;\n  padding: 2px;\n  height: 24px;\n  width: 24px;\n  cursor: pointer;\n"])));
var SortIconElement = (0, _styled["default"])(_IconButton["default"])(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  grid-area: sort;\n  margin: 0 0 0 0.375rem;\n  padding: 2px;\n  height: 24px;\n  width: 24px;\n  cursor: pointer;\n"])));

var FilterIcon = function FilterIcon(_ref9) {
  var active = _ref9.active;
  var theme = (0, _styled.useTheme)();
  return /*#__PURE__*/_react["default"].createElement(FilterIconElement, {
    color: theme.background
  }, /*#__PURE__*/_react["default"].createElement(_react2["default"], {
    path: active ? _js.mdiFilter : _js.mdiFilterOutline,
    color: active ? theme.primary : theme.background,
    size: 0.75
  }));
};

exports.FilterIcon = FilterIcon;

var SortIcon = function SortIcon(_ref10) {
  var active = _ref10.active,
      direction = _ref10.direction;
  var theme = (0, _styled.useTheme)();
  return /*#__PURE__*/_react["default"].createElement(SortIconElement, {
    color: theme.background
  }, /*#__PURE__*/_react["default"].createElement(_react2["default"], {
    path: active && direction === 'desc' ? _js.mdiArrowDown : _js.mdiArrowUp,
    color: active ? theme.primary : theme.background,
    size: 0.75
  }));
};

exports.SortIcon = SortIcon;